import React from 'react';
import styled from 'styled-components';

import { Button } from '../../../components/ui/Button';

const Navigation = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-md);
  margin-top: var(--space-lg);
`;

const PageStatus = styled.span`
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
`;

export interface UserFilesPaginationProps {
  page: number;
  perPage: number;
  total: number;
  onPageChange: (page: number) => void;
}

export const UserFilesPagination: React.FC<UserFilesPaginationProps> = ({
  page,
  perPage,
  total,
  onPageChange,
}) => {
  const pageCount = Math.max(1, Math.ceil(total / perPage));

  if (pageCount <= 1) return null;

  return (
    <Navigation aria-label="Paginación de archivos">
      <Button
        variant="secondary"
        size="sm"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        Anterior
      </Button>
      <PageStatus aria-live="polite">
        Página {page} de {pageCount}
      </PageStatus>
      <Button
        variant="secondary"
        size="sm"
        disabled={page >= pageCount}
        onClick={() => onPageChange(page + 1)}
      >
        Siguiente
      </Button>
    </Navigation>
  );
};
